import { Wording } from '@/types';

export const YOGA_WORDING_CY: Wording = {
  components_header_media_content: 'Προπονήσεις',
  components_header_media_1: '',
  components_header_text1: 'Συνταγές',
  components_header_text2: 'Ιστολόγιο',
  components_header_members: 'Μέλη',
  hero_text: 'Διατηρήστε το σώμα σας ευέλικτο και δυνατό',
  hero_button_text: 'Ξεκινήστε το ταξίδι σας στη γιόγκα',
  components_ressources_section_title: 'ΠΟΡΟΙ',
  components_ressources_subheader_text: 'Όλοι οι πόροι που χρειάζεστε για έναν αρμονικό τρόπο ζωής',
  components_ressources_span_text: 'Ξεκλειδώστε τα μυστικά για την ευεξία: Βουτήξτε σε μια συλλογή από στάσεις γιόγκα, προσεκτικούς διαλογισμούς και υγιεινές συνταγές για να δημιουργήσετε ισορροπία σε κάθε πτυχή της ζωής σας.',
  components_ressources_card_1_title: 'Συμβουλές γιόγκα',
  components_ressources_card_1_text: 'Πρακτικές συμβουλές για να εμβαθύνετε την πρακτική σας και να τελειοποιήσετε τις πόζες σας.',
  components_ressources_card_2_title: 'Διατροφή',
  components_ressources_card_2_text: 'Έξυπνες συμβουλές διατροφής για πιο υγιείς, πιο δυνατούς.',
  components_ressources_link: 'Παρακολουθήστε βίντεο',
  components_notes_and_google_title_1: 'Προπονήσεις γιόγκα',
  components_notes_and_google_title_2: 'Τακτική ρουτίνα',
  components_notes_and_google_title_3: 'Διατήρηση Διατροφής',
  components_review_google_text: 'Αξιολόγηση στο Google',
  media_content_section_title: 'ΠΡΟΠΟΝΗΣΕΙΣ',
  media_content_section_subheader_text: 'Τα βίντεό μας',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Περισσότερα βίντεο',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Άρθρα & Νέα',
  text2_section_button_more: 'Περισσότερα άρθρα',
  components_text1_section_title: 'ΣΥΝΤΑΓΕΣ',
  components_text1_subheader_text: 'Θρέψτε το σώμα και το μυαλό σας',
  components_text1_span_text: 'Χρήσιμες συνταγές για να υποστηρίξετε την πρακτική σας στη γιόγκα και να ενισχύσετε την ευημερία σας.',
  components_text1_card_1_title: 'Δυναμικά πρωινά',
  components_text1_card_1_text: 'Ξυπνήστε με ζωντανά γεύματα που ενισχύουν την ενέργεια.',
  components_text1_card_3_title: 'Ισχυρά συσκευασμένα γεύματα',
  components_text1_card_3_text: 'Ανακαλύψτε νόστιμες και βολικές μεσημεριανές συνταγές σχεδιασμένες για τον ενεργό τρόπο ζωής σας. Από πολύχρωμες σαλάτες μέχρι περιτυλίγματα με πρωτεΐνες, αυτές οι συνταγές σας κρατούν τροφοδοτημένους και συγκεντρωμένους.',
  components_text1_card_2_title: 'Δείπνα για ανάρρωση',
  components_text1_card_2_text: 'Εξερευνήστε μια ποικιλία από άπαχη πρωτεΐνη, δημητριακά ολικής αλέσεως και ζωντανά λαχανικά για ένα ικανοποιητικό τέλος της ημέρας σας.',
  components_text1_link: 'Δείτε όλες τις συνταγές',
  components_footer_text: 'Βρείτε ισορροπία, αναπνεύστε βαθιά: Η γιόγκα σας, το ταξίδι σας.',
  components_footer_info: 'Πληροφορίες',
  components_footer_registration_number: 'Αριθμός εγγραφής',
  components_footer_legal: 'Νομικός',
  components_footer_terms: 'Όροι και Προϋποθέσεις',
  components_footer_privacy: 'Πολιτική Απορρήτου',
  button_load_more: 'Φόρτωση περισσότερων',
  page_media_1_content_hero_text: 'Προπονήσεις γιόγκα',
  page_text1_hero_text: 'Συνταγές',
  page_text1_section_title: 'Θρέψη',
  page_text1_subheader_text: 'Συνταγές',
  page_text2_hero_text: 'Το Blog μας',
  page_text2_section_title: 'Ιστολόγιο',
  page_text2_subheader_text: 'Άρθρα & Νέα',
  enter_email_title: 'Εισαγάγετε το email σας για να συνεχίσετε',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Εισάγω',
  components_login_success_text: 'Επιτυχής σύνδεση!',
  components_card_link_media_content: 'Παρακολουθήστε τώρα',
  components_card_link_text1_content: 'Προβολή Συνταγής',
  components_card_link_text2_content: 'Δείτε το άρθρο',
  france: 'Γαλλία',
  cyprus: 'Κύπρος',
};